// extracted by mini-css-extract-plugin
export default {"content":"pdfSignatureQuickView_content__+O9mM","tableContainer":"pdfSignatureQuickView_tableContainer__q8txS"};